// react
import { useCallback } from 'react';

// components
import CareSearchPage from '@karehero/llama/components/pages/CareSearch/CareSearch';
import { Typography } from '@mui/material';

// views
import Directory from 'views/Directory';

// store
import { useSelector } from 'store';
import {
  useGetShortlistByCareProfileIdQuery,
  useGetShortlistDataByCareProfileIdQuery,
  useMarkShortlistCareHomeSecuredByCareProfileIdMutation,
} from 'store/api/shortlist';
import { useGetCareCircleQuery } from 'store/api/careCircle';
import { getCurrentCareCircle } from 'store/slices/careCircleSlice';
import { useSearchParams } from 'react-router-dom';

/**
 * AdminCareSearch shows a search bar and a list of care homes based on the user's search criteria and shortlist.
 */
export const AdminCareSearch = () => {
  // hooks
  const currentCareCircle = useSelector(getCurrentCareCircle);
  const careCircleId = currentCareCircle?.id;
  const [searchParams] = useSearchParams();

  const { data: careCircle } = useGetCareCircleQuery(careCircleId, {
    skip: !careCircleId,
  });
  const { data: careHomeShortlistData } =
    useGetShortlistDataByCareProfileIdQuery(careCircle?.careProfile?.id || '', {
      skip: !careCircle,
    });
  const { data: careHomeShortlist } = useGetShortlistByCareProfileIdQuery(
    careCircle?.careProfile?.id || '',
    { skip: !careCircle },
  );
  const [markCareHomeSecured] =
    useMarkShortlistCareHomeSecuredByCareProfileIdMutation();

  // callbacks
  const markSecured = useCallback(
    (regulatoryID: string) => {
      return (
        careHomeShortlist &&
        markCareHomeSecured({
          ...careHomeShortlist,
          securedRegulatoryID: regulatoryID,
        })
      );
    },
    [careHomeShortlist, markCareHomeSecured],
  );

  if (!careCircleId) {
    return (
      <Typography
        variant='body1'
        sx={{
          color: 'text.secondary',
          textAlign: 'center',
          p: 4,
        }}
      >
        Please ensure you have selected a care circle.
      </Typography>
    );
  }

  return (
    <>
      {careHomeShortlist &&
        careHomeShortlistData &&
        !searchParams.get('provider') && (
          <CareSearchPage
            shortlist={careHomeShortlist}
            shortlistData={careHomeShortlistData}
            onMarkSecured={markSecured}
          />
        )}
      <Directory />
    </>
  );
};

export default AdminCareSearch;
